module.exports = __webpack_public_path__ + "img/0Q3C0560_Foamcore_MockedUp.c351d1cc.jpg";